// Known white-label guest portal origins. Must mirror WHITE_LABEL_BASE_URLS in
// backend/guest-portal/backend/whiteLabel.ts. On these origins the backend
// resolves the host from the request's Origin header, so no hostCode is needed
// in the URL — /, /portal, and /portal/<hostCode> all work.
export const WHITE_LABEL_ORIGINS: string[] = [
  'https://portal.innsbrookvacations.com',
  'https://guest.sunnyorangestays.com',
  'https://portal.rentkeywest.com',
  'https://guestportal.thetruenorthproperty.com',
  'https://guestportal.vacationrentalsofsantabarbara.com',
  'https://welcome.perfectvacationhouse.com',
  'https://guest.northwestpads.com',
  'https://guest.redsandsvacations.com',
  'https://portal.nomadhospitality.co',
  'https://portal.vacationhomebranson.com',
  'https://portal.ashorehospitality.com',
  'https://portal.seascapeproperties.com',
  'https://addondesk.smvhouserental.com',
  'https://stay.thirdcoastvacations.com',
  'https://portal.ledges.com',
  'https://portal.mckennalodging.com',
  'https://portal.bookmyhomeaway.com',
  'https://portal.metrostaysnyc.com',
  'https://portal.bluewaterbreeze.com',
  'https://portal.bellabeachproperties.com',
  'https://portal.staylivefree.com',
  'https://portal.ikoihomes.com',
  'https://app.elevatedstays.com',
  'https://guestportal.donerightmanagement.com',
  'https://portal.theholidaylife.com',
  'https://portal.roelensvacations.com',
  'https://portal.sunnybeach1.com',
  'https://portal.beachretreatsfl.com',
  'https://portal.brokenbowfamilycabins.com',
  'https://portal.latraystays.com',
  'https://portal.sierrasolelevatedstays.com',
  'https://portal.thirdcoastelevatedstays.com',
  'https://portal.yosemiteelevatedstays.com',
  'https://portal.redwoodcoastelevatedstays.com',
  'https://portal.bearlakeelevatedstays.com',
];

export function isWhiteLabelOrigin(origin: string = window.location.origin): boolean {
  return WHITE_LABEL_ORIGINS.includes(origin);
}
